import { memo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "../Modal";
import { AddArtificialPostcodeContent } from "./AddArtificialPostcodeContent";
import { AddArtificialPostcodeActions } from "./AddArtificialPostcodeActions";
import { addArtificialPostcodeModalOpenSelector } from "../../../reducers/ownApp/selectors";
import {
  setAddArtificialPostcodeModalOpen,
  setSelectedTab,
} from "../../../reducers/ownApp";
import { addArtificialPostcode } from "../../../reducers/depot/thunkActions";
import { lookupTableSelector } from "../../../reducers/depot/selectors";

export const AddArtificialPostcodeModal = memo(() => {
  const dispatch = useDispatch();
  const lookupTables = useSelector(lookupTableSelector);
  const open = useSelector(addArtificialPostcodeModalOpenSelector);
  const [selectedSector, setSelectedSector] = useState(null);
  const [sectorError, setSectorError] = useState(null);
  const [postcodeSuffix, setPostcodeSuffix] = useState("");
  const [suffixError, setSuffixError] = useState(null);
  const isValid =
    !!selectedSector && !!postcodeSuffix && !sectorError && !suffixError;

  useEffect(() => {
    if (!open) {
      setSelectedSector(null);
      setPostcodeSuffix("");
      setSectorError(null);
      setSuffixError(null);
      return;
    }

    if (!selectedSector && postcodeSuffix)
      setSectorError("Sector is required.");
    else setSectorError(null);

    if (postcodeSuffix && !/[A-Z][A-Z]/.test(postcodeSuffix))
      setSuffixError("Invalid postcode suffix.");
    else if (lookupTables.POSTCODE[`${selectedSector}${postcodeSuffix}`])
      setSuffixError("Postcode already exists.");
    else setSuffixError(null);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSector, postcodeSuffix, open]);

  const onClose = () => {
    dispatch(setAddArtificialPostcodeModalOpen(false));
  };
  const onContinue = async () => {
    dispatch(setSelectedTab("Postcodes"));
    dispatch(
      addArtificialPostcode({
        sector: selectedSector,
        postcodeSuffix,
      })
    );
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={"Add New Postcode"}
      content={
        <AddArtificialPostcodeContent
          sectors={Object.keys(lookupTables?.SECTOR || {})}
          selectedSector={selectedSector}
          onSectorChange={({ target }) => setSelectedSector(target.value)}
          postcodeSuffix={postcodeSuffix}
          onPostcodeSuffixChange={({ target }) => {
            setPostcodeSuffix(target.value.slice(0, 2).toUpperCase());
          }}
          sectorError={sectorError}
          suffixError={suffixError}
        />
      }
      actions={
        <AddArtificialPostcodeActions
          disabled={!isValid}
          onCancel={onClose}
          onContinue={onContinue}
        />
      }
      maxWidth={"sm"}
    />
  );
});
